import * as Dialog from '@radix-ui/react-dialog';
import { faengtAussenklickAb } from '@/onboarding/tourSchutz';

// „Von wem kam es?" — die einzige Rückfrage, die dieses Paket stellt.
//
// Sie erscheint genau dann, wenn sie unvermeidlich ist: mehrere
// Beschaffungswege sind offen, und der Server hat sich geweigert zu raten
// (409 mehrere_wege_offen). Bei EINEM offenen Weg gibt es sie nicht — der
// Normalfall am Tresen darf keinen zusätzlichen Tipp kosten (E2).
//
// Ein Ausweg gehört dazu: „Weiß ich nicht" bucht unzugeordnet. Wer eine
// Kiste ohne Lieferschein auspackt, soll den Eingang trotzdem festhalten
// können — sonst wird gar nicht gebucht, und das ist die schlechtere
// Unwahrheit.

export type WegWahl = {
  beschaffung_id: number;
  label: string;
  offen: number;
};

type Props = {
  offen: boolean;
  titel: string;
  wege: WegWahl[];
  onWahl: (beschaffungId: number | null) => void;
  onAbbruch: () => void;
};

export function WegFrage({ offen, titel, wege, onWahl, onAbbruch }: Props) {
  return (
    <Dialog.Root open={offen} onOpenChange={(o) => !o && onAbbruch()}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-[60] bg-ink/30" />
        <Dialog.Content
          onPointerDownOutside={faengtAussenklickAb}
          onInteractOutside={faengtAussenklickAb}
          aria-describedby={undefined}
          data-ueber-tour=""
          className="dialog-mobil-unten fixed left-1/2 top-1/2 z-[60] w-[min(28rem,calc(100vw-2rem))] -translate-x-1/2 -translate-y-1/2 rounded-md border border-line bg-cream p-5 shadow-lg"
        >
          <Dialog.Title className="font-serif text-lg text-ink">Von wem kam es?</Dialog.Title>
          <p className="mt-2 text-sm text-ink-soft">
            {/* „zugeordnet" statt „bestellt" (A12.1/E5): einer der Wege
                kann „Auf Lager" sein, und das ist keine Bestellung. */}
            „{titel}“ ist mehreren Wegen zugeordnet. Zu welchem gehört das, was
            eingetroffen ist?
          </p>
          <div className="mt-4 space-y-2">
            {wege.map((w) => (
              <button
                key={w.beschaffung_id}
                type="button"
                onClick={() => onWahl(w.beschaffung_id)}
                className="flex min-h-[44px] w-full items-center justify-between gap-3 rounded-md border border-line bg-cream-warm px-3 text-sm text-ink hover:border-akzent hover:text-akzent"
              >
                <span className="min-w-0 truncate">{w.label}</span>
                <span className="shrink-0 tabular-nums text-ink-faint">
                  {w.offen} offen
                </span>
              </button>
            ))}
          </div>
          <button
            type="button"
            onClick={() => onWahl(null)}
            className="mt-3 min-h-[44px] w-full rounded-md px-3 text-sm text-ink-soft hover:text-ink"
          >
            Weiß ich nicht — ohne Zuordnung eintragen
          </button>
          <button
            type="button"
            onClick={onAbbruch}
            className="mt-1 min-h-[44px] w-full rounded-md px-3 text-sm text-ink-faint hover:text-coral"
          >
            Abbrechen
          </button>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
